import {useTranslation} from "react-i18next";
import {useContext} from "react";
import {AuthContext} from "../../context/authContext";

const LoadingNoMoreContent = () => {
	const { i18n, t } = useTranslation();
	const {visitor} = useContext(AuthContext);

	return (
		<div className="loading-no-more-content text-white text-center font-semibold mt-2">
			{visitor && visitor.user_id ? t('no_more_content') : t('login_or_register_to_see_content')}
		</div>
	);
}

export default LoadingNoMoreContent;